import {
  copyTextToClipboard,
  defaultCellRenderer,
  defaultCellRenderer as renderer, defaultGroupRenderer as groupRenderer,
  generateMultiFilterConfigFromModel, showConfirmationDialog
} from "../utils/utils.jsx";
import {Contact} from "../../bryntum-lib/models/Contact.jsx";
import {CONTACT_VIEW_COLUMNS} from "./ContactViewColumns.jsx";
import {PERSISTENCE_STATE_KEYS} from "./PersistenceStateKeys.jsx";
import SwivuCellEditor from "../../bryntum-lib/widget/fields/SwivuCellEditor.jsx";
import {SWIVU_GROUP_CONTEXT_MENU_SELECTOR} from "./OtherKeys.jsx";
import {DateHelper, MessageDialog} from "@bryntum/schedulerpro";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemCopyContactToClipboard,
  cellMenuItemRemoveRow,
  cellMenuItemSettingsEditor,
  entityCategorySelector,
  entityStatusSelector,
  entityTagsSelector,
} from "../utils/gridCellMenuUtils.jsx";
import {pluralize} from "../utils/otherUtils.jsx";
import { WIDGET_KEYS } from "./WidgetKeys.jsx";

export const contactGridRowExpander = {
  // refreshOnRecordChange: true, // Todo: fix changing role duplicate grids in rowExpander instead of removing old grid
  dataField: "contactDetail",
  columnPosition: "first",
  column: {
    id: "contact-row-expander",
    draggable: false,
    minWidth: 50
  },
  widget: {
    ref: "contactDetailGrid",
    type: WIDGET_KEYS.swivuModernGrid,
    autoHeight: true,
    stateId: PERSISTENCE_STATE_KEYS.contactNestedGridState,
    style: "margin: auto;",
    columns: [
      { id: "noteText", flex: 1, text: "Note", field: "noteText", editor: true },
      {
        id: "aging",
        field: "aging",
        text: "Age",
        flex: 1,
        editor: false,
        renderer({ value }) {
          return value || value === 0 ? DateHelper.formatCount(value, 'day'): defaultCellRenderer({ value: null });
        },
        groupRenderer({ groupRowFor, count }) {
          return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.formatCount(groupRowFor, 'day'), count }): defaultCellRenderer({ value: null });
        }
      },
      {
        id: "lastUpdatedAt",
        flex: 1,
        text: "Last Update",
        field: "lastUpdatedAt",
        editor: false,
        renderer(e) {
          return e.value ? DateHelper.format(new Date(e.value), 'YYYY/MM/DD'): renderer({ value: null });
        },
      },
      { id: "lastUpdatedBy", flex: 1, text: "Last Updated By", field: "lastUpdatedBy", editor: false, renderer
      },
    ],
    maxWidth: "100%",
    features: {
      cellMenu: false,
      sort: {multiSort: false},
      filter: true,
      group: true,
    },
  },
}


const CONTACT_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Contact),
  entitiesValue: { type: '_swivu_settings', },
  tagsValue: { type: '_swivu_settings' },
  categoryValue: { type: '_swivu_settings' },
  statusValue: { type: '_swivu_settings' },
}

export const contactGridCellMenuItemRemoveRowHandler = (e) => {
  const contactsToRemoveFroBoard = e.selection;
  if (contactsToRemoveFroBoard.length) {
    const isUserSelfContactIncludedInList = contactsToRemoveFroBoard.some((contact) => contact.userSelfContact?.length);
    if (!isUserSelfContactIncludedInList) {
      const contactNames = contactsToRemoveFroBoard.map((contact) => defaultCellRenderer({ value: contact.name })).join("<br/>");
      return showConfirmationDialog({
        title: "Delete Contact(s) From Board",
        message: `<div>Are you sure you want to delete the following contact(s) from the Board?<br/><br/>${contactNames}</div>`
      }).then((isDeleteFromList) => {
        if (isDeleteFromList) {
          e.project.contactsStore.remove(contactsToRemoveFroBoard);
        }
        return isDeleteFromList;
      });
    } else {
      MessageDialog.alert({ title: "Cannot Delete Contact's", message: "The contact's to be deleted includes board user contact which cannot be deleted." })
    }
  }
}

const CONTACTS_GRID_CONFIG = {
  columns: CONTACT_VIEW_COLUMNS,
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll",
    "swivuContactStoreFilter",
    "swivuContactStoreSort",
    "swivuContactStoreGroup"
  ],
  preserveScrollOnDatasetChange: true,
  filterFeature: {
    pickerConfig: {
      fields: CONTACT_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  regionResizeFeature: true,
  subGridConfigs: {
    locked: {
      weight: 20
    },
    normal: {
      weight: 30
    }
  },
  cls: "swivu-contacts-grid",
  cellEditFeature: { editorClass: SwivuCellEditor },
  rowExpanderFeature: contactGridRowExpander,
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      filterMenu: false,
      removeRow: cellMenuItemRemoveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      settingsEditor: cellMenuItemSettingsEditor(),
      copyToClipboard: cellMenuItemCopyContactToClipboard({
        onItem(e) {
          const selectedContacts = e.selection;
          if (selectedContacts.length) {
            const contactsConcat = selectedContacts.map((contact) => {
              const contactName = defaultCellRenderer({ value: contact.name });
              const contactPhone = defaultCellRenderer({ value: contact.phone });
              const contactEmail = defaultCellRenderer({ value: contact.email });
              const contactAddress = defaultCellRenderer({ value: contact.address });
              return `${contactName}, ${contactPhone}, ${contactEmail}, ${contactAddress}`;
            });
            copyTextToClipboard(contactsConcat.join("\n"), `Selected ${pluralize(selectedContacts.length, "contact", "s")} has been copied to clipboard.`);
          }
        }
      }),
      entityStatusSelector: entityStatusSelector(),
      entityCategorySelector: entityCategorySelector(),
      entityTagsSelector: entityTagsSelector()
    },
  },
};

export { CONTACTS_GRID_CONFIG };
